export default __webpack_public_path__ + "static/media/partner_00.a0e7caa5.png";